import { render, staticRenderFns } from "./ShareSignup.vue?vue&type=template&id=b96377ca&"
import script from "./ShareSignup.vue?vue&type=script&lang=js&"
export * from "./ShareSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports